import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ListItemIcon, Menu, MenuItem } from "@mui/material";
export const HMenu = ({ anchorEl, open, handleClose, menuItems, right = "50%", }) => {
    return (_jsx(Menu, { anchorEl: anchorEl, id: "account-menu", open: open, onClose: handleClose, onClick: handleClose, slotProps: {
            paper: {
                elevation: 0,
                sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                    },
                    "&::before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: right,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                    },
                },
            },
        }, transformOrigin: { horizontal: "right", vertical: "top" }, anchorOrigin: { horizontal: "right", vertical: "bottom" }, children: menuItems.map((item, index) => item.isVisible && (_jsxs(MenuItem, { onClick: (e) => {
                e.stopPropagation();
                item.onClick && item.onClick(e);
            }, children: [item.icon && _jsx(ListItemIcon, { children: item.icon }), item.label, item.endIcon && (_jsx(Box, { component: "span", sx: { ml: "auto", display: "flex", alignItems: "center" }, children: _jsx(ListItemIcon, { sx: { display: "flex", justifyContent: "flex-end" }, children: item.endIcon }) })), item.subMenu && item.subMenu] }, index))) }));
};
